/* eslint-disable no-unused-vars */
// Search placeholder text as per JIRA TDF-117 AC3 and TDF-133 AC3
export const SEARCH_PLACEHOLDER_OPEN =
  'Search by ticket number, category, or subject';
export const SEARCH_PLACEHOLDER_CLOSED =
  'Search by ticket number, function name, or subject';

export enum TicketState {
  NEW = 'NEW',
  CLOSED = 'CLOSED',
  RESOLVED = 'RESOLVED',
  OPEN = 'OPEN',
  AWAITING_CUSTOMER = 'AWAITING_CUSTOMER',
  WORK_IN_PROGRESS = 'WORK_IN_PROGRESS',
}

// TDF-1394: the ServiceNow state_label values a ticket can carry while still on the
// Open tab — "Closed" is deliberately excluded (it lives on the Closed tab only).
// These are the exact ServiceNow strings/keys (StatusBadge's StatusValue union),
// used as both the filter's value and, via StatusBadge, its display label.
export const OPEN_TICKET_STATUSES = [
  'New',
  'Open',
  'In Progress',
  'Awaiting Customer',
  'On Hold',
  'Awaiting 3rd party info',
  'Resolved',
] as const;

// TDF-1432/1434: a producer can declare its own short_description/description dynamic
// variables, which would otherwise render a second time alongside NewTicketDrawer's own
// static Subject/Description inputs. The backend already fills short_description/description
// from the client's plain subject/comments when a producer declares them
// (SupportCaseIncidentSubmissionService.persist) — so these are safe for NewTicketDrawer to
// drop from what's rendered/validated rather than shown twice.
export const DUPLICATE_DYNAMIC_FIELD_NAMES = new Set([
  'short_description',
  'description',
]);
